import React, { useState, useEffect, useMemo } from 'react';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Financials from './Financials';

const initialFinanceState = {
    revenue: 0,
    expenses: 0,
    cmTotal: 0,
    cmPercent: 0
}

const FinancialInfo = (props) => {
    const [financials, setFinancials] = useState(initialFinanceState);

    const getFinancials = () => {

        const orders = props.orders.state.sortedData;

        const remCommas = dollarValue => (dollarValue ? dollarValue.replace(/\$|,/g, '') : '');
        const commaFy = (dollarValue) => (dollarValue ? dollarValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '');
        const restrictDecimals = (f) => f.toFixed(2);

        const { revenue, expenses } = orders.reduce((prev, curr) => {
            prev.revenue += parseFloat(remCommas(curr.totalRevenue));
            prev.expenses += parseFloat(remCommas(curr.totalExpenses));
            return prev;
        }, { revenue: 0, expenses: 0 });

        const total = restrictDecimals(revenue - expenses);
        const percent = restrictDecimals((total / revenue) * 100);

        setFinancials({
            revenue: commaFy(restrictDecimals(revenue)),
            expenses: commaFy(restrictDecimals(expenses)),
            cmTotal: commaFy(total),
            cmPercent: percent
        });
    }

    useEffect(getFinancials, [props]);

    return (
        <GridContainer justify='space-around' alignItems='flex-end'>
            <GridItem xs={6} sm>
                <Financials
                    name='# of Orders'
                    val={props.orders.state.sortedData.length}
                />
            </GridItem>
            <GridItem xs={6} sm>
                <Financials
                    name='Filtered Revenue'
                    type='revenue'
                    val={financials.revenue}
                />
            </GridItem>
            <GridItem xs={6} sm>
                <Financials
                    name='Filtered Expenses'
                    type='expense'
                    val={financials.expenses}
                />
            </GridItem>
            <GridItem xs={6} sm>
                <Financials
                    name='Filtered Contribution'
                    type='revenue'
                    val={financials.cmTotal}
                />
            </GridItem>
            <GridItem xs={6} sm>
                <Financials
                    name='Filtered Contribution Percent'
                    type='percent'
                    val={financials.cmPercent}
                />
            </GridItem>
        </GridContainer>
    );
}

export default FinancialInfo;


// WEBPACK FOOTER //
// ./src/components/Financials/index.jsx